const cache=new Map(),PHI=Math.PI*(3-Math.sqrt(5));
export const VOICE_ENERGY={inactivo:.18,escuchando:.62,pensando:.85,hablando:1,ejecutando:.94,exito:.5,interrumpido:.06,error:.12};
export const VOICE_PACE={inactivo:.55,escuchando:1.05,pensando:1.65,hablando:1.25,ejecutando:1.9,exito:.72,interrumpido:.12,error:.28};
export function buildParticleField(small=false,canvas=false){
 const key=small+":"+canvas;if(cache.has(key))return cache.get(key);
 const count=canvas?(small?340:580):(small?850:1400),dust=canvas?(small?150:240):(small?800:1200);
 const nodes=[],edges=[],cell=canvas?.29:(small?.2:.16),buckets=new Map();
 let seed=2047;const random=()=>{seed=(Math.imul(seed,1664525)+1013904223)>>>0;return seed/4294967296};
 const bucket=(x,y,z)=>[Math.floor(x/cell),Math.floor(y/cell),Math.floor(z/cell)];
 for(let i=0;i<count;i++){
  const y=1-2*(i+.5)/count,a=i*PHI,r=Math.sqrt(1-y*y);
  const p=[Math.cos(a)*r,y,Math.sin(a)*r,random()*6.283,0];nodes.push(p);
  const [bx,by,bz]=bucket(...p),k=[bx,by,bz].join(",");if(!buckets.has(k))buckets.set(k,[]);buckets.get(k).push(i);
 }
 for(let i=0;i<count;i++){
  const p=nodes[i],[bx,by,bz]=bucket(...p),candidates=[];
  for(let x=-1;x<=1;x++)for(let y=-1;y<=1;y++)for(let z=-1;z<=1;z++){
   for(const j of buckets.get([bx+x,by+y,bz+z].join(","))||[]){
    if(j<=i)continue;const q=nodes[j],d=(p[0]-q[0])**2+(p[1]-q[1])**2+(p[2]-q[2])**2;
    if(d<cell*cell*1.8)candidates.push([d,j]);
   }
  }
  candidates.sort((a,b)=>a[0]-b[0]);for(const [,j] of candidates.slice(0,3))edges.push([i,j]);
  if(i%19===0){const j=(i+89)%count,q=nodes[j],d=(p[0]-q[0])**2+(p[1]-q[1])**2+(p[2]-q[2])**2;if(d<.7)edges.push([i,j]);}
 }
 for(let i=0;i<dust;i++){const y=random()*2-1,a=random()*6.283,r=Math.sqrt(1-y*y),shell=.8+random()*.56;nodes.push([Math.cos(a)*r*shell,y*shell,Math.sin(a)*r*shell,random()*6.283,1]);}
 // A small transparent nucleus, not an opaque sphere.
 nodes.push([0,0,0,0,2]);
 const points=new Float32Array(nodes.flat()),lines=new Float32Array(edges.flatMap(([a,b])=>[...nodes[a],...nodes[b]]));
 const field={points,lines,nodes,edges};cache.set(key,field);return field;
}
export function createCanvasFieldRenderer(ctx,{size,small}){
 const {nodes,edges}=buildParticleField(small,true),TAU=Math.PI*2;
 let phase=0,energy=.18,pace=.55;
 const clamp=(v,a,b)=>Math.max(a,Math.min(b,v));
 return {render(seconds,state,delta,audioLevel){
  const blend=Math.min(1,delta*.004);const target=state==="escuchando"&&Number.isFinite(audioLevel)?Math.max(.12,Math.min(1.2,.12+audioLevel)):VOICE_ENERGY[state]??.18;energy+=(target-energy)*blend;pace+=((VOICE_PACE[state]??.55)-pace)*blend;
  if(seconds!==0)phase+=delta*.001*pace;
  const t=phase*.7,rot=t*.2,tilt=.22,cs=Math.cos(rot),sn=Math.sin(rot),ca=Math.cos(tilt),sa=Math.sin(tilt);
  ctx.clearRect(0,0,size,size);
  const halo=ctx.createRadialGradient(size*.5,size*.5,0,size*.5,size*.5,size*.46);
  halo.addColorStop(0,"rgba(28,140,250,.09)");halo.addColorStop(.45,"rgba(18,107,230,.035)");halo.addColorStop(1,"rgba(0,40,100,0)");
  ctx.fillStyle=halo;ctx.fillRect(0,0,size,size);ctx.globalCompositeOperation="lighter";
  const projected=nodes.map(([x,y,z,seed,kind])=>{
   const len=Math.sqrt(x*x+y*y+z*z)||1,nx=x/len,ny=y/len,nz=z/len;
   const f=Math.sin(nx*3.8+nz*2.5+t*.67),g=Math.cos(ny*4.7-nx*2.4-t*.58);
   const deformation=1+(.055+energy*.13)*f*g+(.045+energy*.035)*Math.sin(nz*5.2+ny*2.8+t*.8);
   const twist=(.14+energy*.08)*Math.sin(ny*3+t*.25),c=Math.cos(twist),s=Math.sin(twist);
   const xx=(x*c-z*s)*deformation,zz=(x*s+z*c)*deformation,yy=y*deformation;
   const xr=xx*cs-zz*sn,zr=xx*sn+zz*cs,yr=yy*ca-zr*sa,depth=yy*sa+zr*ca,ps=3.6/(3.6-depth*.45);
   const coverage=clamp((Math.sin(nx*3.3+t*.2)*Math.cos(nz*4.1-t*.16)+.45*Math.sin(ny*5.7+t*.19)+.15)/.9,0,1);
   return {x:size*.5+xr*size*.3*ps,y:size*.5+yr*size*.3*ps,z:depth,coverage,seed,kind};
  });
  const rgb=state==="error"?"120,180,255":"110,220,255";
  for(const [a,b] of edges){const p=projected[a],q=projected[b],mask=Math.min(p.coverage,q.coverage);if(mask<.12)continue;
   ctx.beginPath();ctx.moveTo(p.x,p.y);ctx.lineTo(q.x,q.y);ctx.lineWidth=.6;ctx.strokeStyle="rgba("+rgb+","+((.04+mask*.42)*(.45+(p.z+1)*.24))+")";ctx.stroke();
  }
  for(const p of projected){if(p.kind===2)continue;const front=clamp((p.z+1.4)/2.8,0,1),opacity=(p.kind?.15+.32*front:(.16+.65*p.coverage)*(.4+.6*front));
   ctx.fillStyle="rgba("+rgb+","+opacity+")";ctx.beginPath();ctx.arc(p.x,p.y,p.kind?.45+.4*front:.55+.65*front,0,TAU);ctx.fill();
  }
  ctx.globalCompositeOperation="source-over";
 }};
}
